import { render, staticRenderFns } from "./CustomFormModeForm.vue?vue&type=template&id=728ffd65&scoped=true&"
import script from "./CustomFormModeForm.vue?vue&type=script&lang=ts&"
export * from "./CustomFormModeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ffd65",
  null
  
)

export default component.exports